'use strict';

var React = require('react');

var SvgWandMajor = function SvgWandMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.666.376c.495-.501 1.189-.501 1.684 0l2.278 2.307c.496.502.496 1.204 0 1.706l-3.665 3.611-3.963-4.013 3.666-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.993 5 4.007 4.007-10.618 10.617c-.5.501-1.202.501-1.703 0l-2.303-2.303c-.501-.501-.501-1.203 0-1.703l10.617-10.618Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 13c0-.6.4-1 1-1s1 .4 1 1 .4 1 1 1 1 .4 1 1-.4 1-1 1-1 .4-1 1-.4 1-1 1-1-.4-1-1-.4-1-1-1-1-.4-1-1 .4-1 1-1 1-.4 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 1c0-.6.4-1 1-1s1 .4 1 1 .4 1 1 1 1 .4 1 1-.4 1-1 1-1 .4-1 1-.4 1-1 1-1-.4-1-1-.4-1-1-1-1-.4-1-1 .4-1 1-1 1-.4 1-1Z"
  }));
};

exports.SvgWandMajor = SvgWandMajor;
